import { render, staticRenderFns } from "./CreateNewModal.vue?vue&type=template&id=6734314e&scoped=true"
import script from "./CreateNewModal.vue?vue&type=script&lang=js"
export * from "./CreateNewModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewModal.vue?vue&type=style&index=0&id=6734314e&prod&scoped=true&lang=scss"
import style1 from "./CreateNewModal.vue?vue&type=style&index=1&id=6734314e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734314e",
  null
  
)

export default component.exports